import { Box, Button, Flex, Stack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import Instructions from "./Instructions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SheetUploaderBox from "./SheetUploaderBox";
import { toast } from "react-toastify";
import { getClientAuditStatus, getClientIdForAudtiSheet, uploadAuditSheets } from "../../actions/audit/auditUploadActions";
import Loader from "../../components/Loader/Loader";

import { areArraysEqual } from "../../utils/helperFunction";
import {
  BALANCE_SHEET,
  PROFIT_LOSS_STATEMENT,
} from "../../utils/Stringconstant";
import { balanceSheetReqBody, IncomeStatReqBody } from "./helper";
import { allUnits } from "../../assets/auditSheetFormats";
import PerformanceReportingStatus from "./PerformanceReportingStatus";
import { FiAlertTriangle } from "react-icons/fi";

const AuditSheetUploader = ({ clientData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const balanceSheetRef = useRef(null);
  const statementRef = useRef(null);

  const [unit, setUnit] = useState("");
  const [balanceSheet, setBalanceSheetData] = useState("");
  const [rawBalanceSheet, setRawBalanceSheetData] = useState("");
  const [profitLoss, setStatementSheetData] = useState("");
  const [rawProfitLoss, setRawStatementSheetData] = useState("");
  const [balanceSheetEntryYears, setBalanceSheetEntryYears] = useState([]);
  const [statSheetEntryYears, setStatSheetEntryYears] = useState([]);
  const [balanceSheetFile, setBalanceSheetFile] = useState(null);
  const [statementSheetFile, setStatementSheetFile] = useState(null);

  const { loading: auditLoading, data: auditClientStatus } = useSelector(
    (state) => state.auditUploadStatusReducer
  );

  const { clientId } = useParams();

  const getAuditSheetForClient = () => {
    dispatch(getClientAuditStatus(clientId));
  };

  const balanceSheetRefOnClickHandler = (e) => {
    balanceSheetRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const statementRefOnClickHandler = (e) => {
    statementRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!unit) {
      toast.error("Please select your unit to Proceed", {
        toastId: "unit-empty",
        position: "bottom-center",
      });
      return;
    }
    if (!balanceSheet) {
      toast.error("Please Upload Your Balance Sheet to Proceed", {
        toastId: "bal-sheet-empty",
        position: "bottom-center",
      });
      return;
    }

    if (!profitLoss) {
      toast.error("Please Upload Your Statement Sheet to Proceed", {
        toastId: "st-sheet-empty",
        position: "bottom-center",
      });
      return;
    }

    if (!areArraysEqual(balanceSheetEntryYears, statSheetEntryYears)) {
      toast.error("Both sheets must have data for equal number of years", {
        toastId: "unequal-cols",
        position: "bottom-center",
      });
      return;
    }
    const reqBodyB_S = balanceSheetReqBody(balanceSheet, unit);
    const reqBodyP_L = IncomeStatReqBody(profitLoss, unit);
    const reqBodyRawBS = rawBalanceSheet;
    const reqBodyRawIS = rawProfitLoss;
    console.log("===clientId,", clientId);
    let uploadCurrentYear = "";
    dispatch(
      uploadAuditSheets(
        uploadCurrentYear,
        clientId,
        allUnits.find((val) => val.value === Number(unit)).name,
        reqBodyB_S,
        reqBodyP_L,
        reqBodyRawBS,
        reqBodyRawIS,
        navigate
      )
    );
    // Reset the state here after dispatch
    setBalanceSheetFile(null);
    setStatementSheetFile(null);
    setBalanceSheetData("");
    setStatementSheetData("");
    setUnit("");

    toast.success(
      '⚠️ This will SUBMIT the current information. Any future EDITS to past audited financial performance will require Admin consent. You can VERIFY in "View Past Performance" tab.',
      {
        position: "bottom-center",
      }
    );
  };

  useEffect(()=>{
    getAuditSheetForClient()
  },[])

  return (
    <>
      <Box className="uploadBalanceload">
        <Stack p={"5px"} height={"395px"} overflow={"auto"}>
          <Instructions
            balanceSheetRefOnClickHandler={balanceSheetRefOnClickHandler}
            statementRefOnClickHandler={statementRefOnClickHandler}
            setUnit={setUnit}
            unit={unit}
          />
          <PerformanceReportingStatus
            auditClientStatus={auditClientStatus}
            auditLoading={auditLoading}
          />
        </Stack>
        <Stack
          className="uploadContainer"
          height={"395px"}
          width={"40%"}
          overflow={"auto"}
        >
          <Box className="heading">Upload Statements</Box>
          <Box className="body">
            <Flex justifyContent={"space-between"}>
              <SheetUploaderBox
                setAllyears={setBalanceSheetEntryYears}
                labelName={"Balance Sheet"}
                boxName={BALANCE_SHEET}
                boxRef={balanceSheetRef}
                setData={setBalanceSheetData}
                setRawData={setRawBalanceSheetData}
                clientData={clientData}
                unit={unit}
              />
            </Flex>
            <Flex justifyContent={"space-between"}>
              <SheetUploaderBox
                setAllyears={setStatSheetEntryYears}
                labelName={"Profit & Loss Sheet"}
                boxName={PROFIT_LOSS_STATEMENT}
                boxRef={statementRef}
                setData={setStatementSheetData}
                setRawData={setRawStatementSheetData}
                clientData={clientData}
                unit={unit}
              />
            </Flex>

            <Flex justifyContent={"space-around"} pt={"20px"}>
              <Button onClick={submitHandler}>Submit</Button>
            </Flex>

            <Box
              style={{
                backgroundColor: "#FFAA00",
                color: "#1E1E1E",
                borderRadius: "8px",
                padding: "13px 18px",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              <Flex>
                <Box>
                  <FiAlertTriangle style={{ height: "30px", width: "30px" }} />
                </Box>
                <Box style={{ margin: "3px 5px" }}>
                  Data ranging for past audited years cannot be changed,
                  modified or altered once statements have been submitted for
                  these years.
                </Box>
              </Flex>

              <Box className="ml-2">
                <p className="mt-2">For support, contact abc@sylvr.io</p>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default AuditSheetUploader;
